const typographyTablesActions = {
  clearFilter: 'Borrar todos',
  noResults: 'Ningún resultado encontrado'
};

export default typographyTablesActions;
